import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const BRAND = [180, 101, 74];
const DARK = [23, 23, 23];

const TIPO_LABELS = {
  azienda: "Azienda",
  rivenditore: "Rivenditore",
  agente: "Agente",
  modello: "Modello",
  finitura: "Finitura",
  tipologia: "Tipologia",
  modello_living: "Modello Living",
  data_sviluppata: "Data Sviluppata",
  data_definita: "Data Definita",
  prende_posto_di: "Prende il posto di",
  stato: "Stato",
};

function header(doc, subtitle) {
  doc.setFillColor(...DARK);
  doc.rect(0, 0, doc.internal.pageSize.getWidth(), 26, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(16);
  doc.text("CUCINE EXPO", 14, 13);
  doc.setFontSize(9);
  doc.setTextColor(200, 200, 200);
  doc.text(subtitle, 14, 20);
  doc.setTextColor(...BRAND);
  doc.setFontSize(8);
  doc.text(new Date().toLocaleDateString("it-IT"), doc.internal.pageSize.getWidth() - 14, 13, { align: "right" });
}

export function exportFullList(kitchens) {
  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
  header(doc, "Elenco completo esposizioni cucine");

  const columns = [
    "Azienda", "Rivenditore", "Agente", "Modello", "Finitura",
    "Tipologia", "Living", "Sviluppata", "Definita", "Sostituisce", "Stato",
  ];
  const rows = kitchens.map((k) => [
    k.azienda, k.rivenditore, k.agente, k.modello, k.finitura,
    k.tipologia, k.modello_living, k.data_sviluppata, k.data_definita, k.prende_posto_di, k.stato,
  ]);

  autoTable(doc, {
    head: [columns],
    body: rows,
    startY: 32,
    styles: { fontSize: 7, cellPadding: 2, textColor: DARK, lineColor: [229, 229, 229], lineWidth: 0.1 },
    headStyles: { fillColor: DARK, textColor: [255, 255, 255], fontStyle: "bold", fontSize: 7 },
    alternateRowStyles: { fillColor: [249, 249, 248] },
  });

  doc.save(`elenco-cucine-${Date.now()}.pdf`);
}

export function exportKitchenCard(k) {
  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  header(doc, "Scheda cucina");

  doc.setTextColor(...DARK);
  doc.setFontSize(24);
  doc.setFont("helvetica", "normal");
  doc.text(k.modello || "Cucina", 14, 44);
  doc.setDrawColor(...BRAND);
  doc.setLineWidth(0.8);
  doc.line(14, 48, 60, 48);

  const fields = Object.keys(TIPO_LABELS);
  const body = fields.map((f) => [TIPO_LABELS[f], k[f] || "—"]);

  autoTable(doc, {
    body,
    startY: 56,
    theme: "plain",
    styles: { fontSize: 11, cellPadding: 3.5, textColor: DARK },
    columnStyles: {
      0: { cellWidth: 60, textColor: [120, 120, 120], fontSize: 9 },
      1: { fontStyle: "bold" },
    },
    didDrawCell: (data) => {
      if (data.section === "body" && data.column.index === 0) {
        doc.setDrawColor(235, 235, 235);
        doc.setLineWidth(0.1);
        doc.line(data.cell.x, data.cell.y + data.cell.height, data.cell.x + 180, data.cell.y + data.cell.height);
      }
    },
  });

  doc.save(`scheda-${(k.modello || "cucina").replace(/\s+/g, "-")}.pdf`);
}
